<template>
	<div class="">
		<label :for="fieldId" class="uk-form-label">{{ fieldLabel }}</label>

		<div class="uk-form-controls">
			<input :id="fieldId" type="number" :name="fieldName" v-model="fieldValue" class="uk-input" min=1 max=5 @blur.prevent="sendValue" />
		</div>
	</div>
</template>

<script>
import Format from "../Classes/Format";
export default {
	name: "RatingField",
	props:{
		requestSlug:{
			type: String,
			default: ""
		},
		placementId:{
			type: Number,
			default: 0
		},
		categoryId:{
			type: Number,
			default: 0
		},
		fieldName:{
			type: String,
			default: ""
		},
		fieldLabel:{
			type: String,
			default: ""
		},
		startValue:{
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			fieldId: "",
			fieldValue: 0
		}
	},
	mounted() {
		this.fieldId = Format.randomString() + this.fieldName;
		this.fieldValue = this.startValue;
	},
	methods: {
		sendValue(){
			axios.post("/api/rating/sheet/" + this.requestSlug, {
				rating: this.fieldValue,
				placementId: this.placementId,
				categoryId: this.categoryId,
			}).then(
				(pack) => this.resultCatcher(pack),
				(pack) => this.resultCatcher(pack),
			)
		},
		resultCatcher(pack){
			console.log(pack);
		}
	}
}
</script>
<style scoped></style>